import request from '@/utils/request'

// 获取用户列表
export function getUserList() {
  return request({
    url: '/api/user/getUserList',
    method: 'get'
  })
}

// 获取用户详情
export function getUserDetail(id) {
  return request({
    url: `/api/user/detail/${id}`,
    method: 'get'
  })
}

// 删除用户
export function deleteUser(data) {
  return request({
    url: '/api/staff/delete',
    method: 'post',
    data: {
      data
    }
  })
}

// 编辑用户
export function editUser(data) {
  return request({
    url: '/api/admin/user/editUser',
    method: 'post',
    data: {
      data
    }
  })
}

// 验证用户ID
export function reqValidatUserID(data) {
  return request({
    url: '/api/staff/validatUserID',
    method: 'post',
    data: {
      data
    }
  })
}

// 添加用户
export function addUser(data) {
  return request({
    url: '/api/admin/user/addUser',
    method: 'post',
    data: {
      data
    }
  })
}

// 搜索用户
export function searchUsers(keyword) {
  return request({
    url: '/api/user/search',
    method: 'get',
    params: {
      keyword
    }
  })
}

// 清空用户登录状态
export function clearUserLoginStatus(_id) {
  return request({
    url: `/api/user/clearUserLoginStatus/${_id}`,
    method: 'post'
  })
}

// 根据手机号搜索用户（支持staff和user）
export const searchUsersByPhone = (params) => {
    return request({
        url: '/api/user/search',
        method: 'get',
        params
    });
};


// 一个接口解决
export function getUserListWithPagination(params) {
  return request({
    url: '/api/user/getUserListWithPagination',
    method: 'get',
    params
  })
}

// 获取用户健康档案历史时间轴
export function getUserTimeline(id) {
  return request({
    url: `/api/user/timeline/${id}`,
    method: 'get'
  })
}

// 医生专属用户列表与搜索（带管理组隔离、PRO及年龄过滤）
export function getDoctorUserList(params) {
  return request({
    url: '/api/doctor/user/list',
    method: 'get',
    params
  })
}

// 管理员分配用户给指定医生或健康管理组
export function assignUserToDoctor(data) {
  return request({
    url: '/api/user/assign-doctor',
    method: 'post',
    data
  })
}
